import { InstrumentationBase, } from '@opentelemetry/instrumentation';
import { CUSTOM_MEASUREMENT_INSTRUMENTATION_NAME, CUSTOM_MEASUREMENT_INSTRUMENTATION_VERSION, } from './instrumentation.consts';
import { CoralogixEventType, } from '../types';
import { CoralogixAttributes } from '../constants';
export class CoralogixCustomMeasurementInstrumentation extends InstrumentationBase {
    constructor(config) {
        super(CUSTOM_MEASUREMENT_INSTRUMENTATION_NAME, CUSTOM_MEASUREMENT_INSTRUMENTATION_VERSION, config);
    }
    init() { }
    disable() { }
    enable() { }
    createCustomMeasurement(name, value) {
        const customMeasurementSpan = this.tracer.startSpan(CUSTOM_MEASUREMENT_INSTRUMENTATION_NAME);
        customMeasurementSpan[CoralogixAttributes.EVENT_TYPE] =
            CoralogixEventType.CUSTOM_MEASUREMENT;
        customMeasurementSpan[CoralogixAttributes.CUSTOM_MEASUREMENT_CONTEXT] = {
            name,
            value,
        };
        customMeasurementSpan.end();
    }
}
